import React, { useEffect, useMemo } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Modal, Typography } from "antd";
import CustomSelect from "../../Common/CustomSelect";
import CustomInput from "../../Common/CustomInput";
import { useCreateSurveyMutation } from "../../../store/api/formbricks/survey";
import { useCreateLongLivedTokenMutation } from "../../../store/api/lumi/auth";

const CreateTokenModal = ({ onClose, isOpen }) => {
    const [createLongLivedToken] = useCreateLongLivedTokenMutation();
    const defaultValues = useMemo(
        () => ({
            password: "",
        }),
        []
    );

    const methods = useForm({ defaultValues });

    const {
        control,
        reset,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = methods;

    const closeModalHandler = () => {
        onClose();
        reset(defaultValues);
    };

    const submitFormHandler = async (data) => {
        try {
            const { result } = await createLongLivedToken(data).unwrap();
            if (result.token)
                localStorage.setItem("long_lived_token", result.token);
            closeModalHandler();
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        reset(defaultValues);
    }, [defaultValues, reset]);

    return (
        <Modal
            width="60%"
            style={{ maxHeight: "80%", overflow: "auto", paddingBottom: 0 }}
            open={isOpen}
            onCancel={closeModalHandler}
            okButtonProps={{
                form: "create-long-lived-token",
                htmlType: "submit",
                loading: isSubmitting,
            }}
        >
            <FormProvider {...methods}>
                <form
                    id="create-long-lived-token"
                    onSubmit={handleSubmit(submitFormHandler)}
                    style={{
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                    }}
                >
                    <Typography>
                        Please, repeat your password to continue
                    </Typography>
                    <Controller
                        control={control}
                        name="password"
                        render={({ field }) => (
                            <CustomInput
                                required
                                errors={errors}
                                label="Password *"
                                type="password"
                                {...field}
                            />
                        )}
                    />
                </form>
            </FormProvider>
        </Modal>
    );
};

export default CreateTokenModal;
